import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Infinity as InfinityIcon } from 'lucide-react';
export function PricingCta() {
  return <section id="pricing" className="py-16 md:py-24 px-4 bg-white relative overflow-hidden" data-id="element-95">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-orange-light/20 rounded-full blur-3xl -z-10" data-id="element-96"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-orange p-8 md:p-12 relative" data-id="element-98">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-orange text-white px-6 py-2 rounded-full font-bold shadow-lg whitespace-nowrap" data-id="element-99">
            🔥 OFERTA POR TIEMPO LIMITADO
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6 mt-4" data-id="element-100">
            Recupera el control de tu cuerpo hoy mismo.
          </h2>

          <p className="text-xl text-charcoal-light mb-8 max-w-2xl mx-auto" data-id="element-101">
            No esperes a que la inflamación se convierta en un problema crónico
            de salud.
          </p>

          <div className="mb-8" data-id="element-102">
            <p className="text-charcoal-light font-medium mb-2 uppercase tracking-wider text-sm" data-id="element-103">
              Precio Especial de Lanzamiento
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-104">
              <span className="text-3xl text-gray-400 line-through font-medium" data-id="element-105">
                $49.99
              </span>
              <span className="text-6xl font-bold text-forest" data-id="element-106">
                $9.99 <span className="text-2xl text-forest-light" data-id="element-107">USD</span>
              </span>
            </div>
            <div className="flex items-center justify-center gap-3 mt-3" data-id="element-108">
              <span className="bg-forest text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-109">
                Ahorras $40.00
              </span>
              <span className="bg-orange text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-110">
                -80% OFF
              </span>
            </div>
          </div>

          <a href="https://theassetsvault.com/cart/53893078679862:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto text-center bg-orange hover:bg-orange-hover text-white font-bold text-xl py-5 px-10 rounded-2xl shadow-[0_8px_30px_rgb(232,114,28,0.3)] hover:shadow-[0_8px_40px_rgb(232,114,28,0.5)] transform hover:-translate-y-1 transition-all duration-300 mb-8" data-id="element-111">
            ¡QUIERO MI RESETEO DE 24 HORAS AHORA!
          </a>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-charcoal font-medium bg-cream p-4 rounded-xl" data-id="element-112">
            <div className="flex items-center gap-2" data-id="element-113">
              <ShieldCheck className="w-5 h-5 text-forest" data-id="element-114" />
              <span data-id="element-115">Pago seguro y cifrado</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-gray-300" data-id="element-116"></div>
            <div className="flex items-center gap-2" data-id="element-117">
              <Zap className="w-5 h-5 text-forest" data-id="element-118" />
              <span data-id="element-119">Acceso inmediato</span>
            </div>
            <div className="hidden sm:block w-px h-6 bg-gray-300" data-id="element-120"></div>
            <div className="flex items-center gap-2" data-id="element-121">
              <InfinityIcon className="w-5 h-5 text-forest" data-id="element-122" />
              <span data-id="element-123">Acceso de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}